import { WhiteboardWrapper } from "../common/components/WhiteboardWrapper";

export const WhiteboardPage = () => {
    return (
        <WhiteboardWrapper />
    );
}